"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryStringParser = void 0;
var _stringToBool = require("./stringToBool");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QueryStringParser = exports.QueryStringParser = /*#__PURE__*/function () {
  function QueryStringParser() {
    var _this = this;
    _classCallCheck(this, QueryStringParser);
    _defineProperty(this, "booleans", ["practice", "fastPlay", "sound", "vibrateAllowed", "autoAdjustBetAllowed", "autoPlayAllowed", "spaceToSpinAllowed", "fastPlayAllowed", "blitzAllowed", "displayClock", "sgaBar", "blitz", "hsAllowed", "showRtpVolatilityInfo", "malMsg", "sgn", "hideExitButton", "ftb", "hri", "replay"]);
    _defineProperty(this, "numbers", ["iId", "spinDuration", "spinDurationMin", "rcIntervalTime", "rcCurrentSessionTime", "pfri", "pfrr", "rmmid"]);
    _defineProperty(this, "parse", function () {
      var config;

      // get querystring
      var queryString = window.location.search.substring(1);
      // if its not a blank string, parse it.

      if (queryString != "") {
        config = _this.parseString(queryString);
      }
      if (config.secret) {
        // decode.
        var decoded = atob(config.secret);
        config = _this.parseString(decoded);
      }
      return config;
    });
  }
  return _createClass(QueryStringParser, [{
    key: "parseString",
    value: function parseString(queryString) {
      var configState = {};
      var pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        // this is so we get correct datatype.
        if (this.numbers.indexOf(decodeURIComponent(pair[0])) > -1) {
          configState[decodeURIComponent(pair[0])] = parseInt(decodeURIComponent(pair[1] || ""));
        } else if (this.booleans.indexOf(decodeURIComponent(pair[0])) > -1) {
          configState[decodeURIComponent(pair[0])] = (0, _stringToBool.stringToBool)(decodeURIComponent(pair[1] || ""));
        } else {
          configState[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
        }
      }
      return configState;
    }
  }]);
}();
//# sourceMappingURL=queryStringParser.js.map